import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory } from 'react-router';

import Button from '../../../../../Button';
import CloseIcon from '../../../../../../icons/CloseIcon';
import HamburgerIcon from '../../../../../../icons/HamburgerIcon';
import CollapsableItem from './components/CollapsableItem';
import getConfig from '../../../../../../../util/config';
import SearchIcon from '../../../../../../icons/SearchIcon';
import { getAsset } from '../../../../../../../util/assets';
import Logo from '../../../../../Logo';

const propTypes = {
  signupDisabled: PropTypes.bool,
  isProView: PropTypes.bool,
};
const CollapsableMenu = ({ signupDisabled, isProView }) => {
  const history = useHistory();
  const { marcomUrl } = getConfig();
  const [expanded, setExpanded] = useState(false);

  const menuClasses = classNames({
    'marcom-layout-collapsable-menu': true,
    'marcom-layout-collapsable-menu-expanded': expanded,
  });
  const contentClasses = classNames({
    'marcom-layout-collapsable-menu-content': true,
    'marcom-layout-collapsable-menu-content-visible': expanded,
  });

  return (
    <div className={menuClasses}>
      <div className="collapsable-menu-toggle">
        <Logo
          logoSrc={getAsset(
            isProView ? '/waldo-logo-pro.svg' : '/waldo-logo.svg',
          )}
          linksTo={marcomUrl}
          externalLink
        />
        <Button btnStyle="reset" onClick={() => setExpanded(prev => !prev)}>
          {!expanded && (
            <HamburgerIcon size={16} color="#646e71" className="ml-auto" />
          )}
          {expanded && (
            <CloseIcon size="16px" color="#646e71" className="ml-auto" />
          )}
        </Button>
      </div>

      <div className={contentClasses}>
        <CollapsableItem label="Personal">
          <a href={`${marcomUrl}/everyday-sharing/?`}>Everyday sharing</a>
          <a href={`${marcomUrl}/special-events/?`}>Special events</a>
          <a href={`${marcomUrl}/slideshows/?`}>Smart slideshows</a>
          <a href={`${marcomUrl}/group-video/?`}>Group video</a>
          <a href={`${marcomUrl}/video-guestbook/?`}>Video guestbook</a>
          <a href={`${marcomUrl}/waldogram/?`}>Waldograms</a>
        </CollapsableItem>
        <CollapsableItem label="Business">
          <a href="https://waldo.pro/" className="text-extra-bold text-primary">
            Pro photographers &ndash; Check out WaldoPro!
          </a>
          <hr />
          <a href={`${marcomUrl}/camps/`}>Camps</a>
          <a href={`${marcomUrl}/churches/`}>Churches</a>
          <a href={`${marcomUrl}/corporate/`}>Corporate</a>
          <a href={`${marcomUrl}/events/`}>Event organizers &amp; venues</a>
          <a href={`${marcomUrl}/greek/`}>Greek organizations</a>
          <a href={`${marcomUrl}/resorts/`}>Resorts &amp; attractions</a>
          <a href={`${marcomUrl}/schools/`}>Schools</a>
          <a href={`${marcomUrl}/sports/`}>Youth sports</a>
        </CollapsableItem>
        <CollapsableItem label="Pricing">
          <a href={`${marcomUrl}/pricing/?`}>Everyday sharing</a>
          <a href={`${marcomUrl}/pricing/special-events/?`}>Special events</a>
          <a href={`${marcomUrl}/pricing/business/?`}>Business</a>
        </CollapsableItem>
        <div className="marcom-layout-menu-collapsable-call-to-actions">
          <Button
            btnOutline
            btnBlock
            onClick={() => history.push(`/shutterbug/signin`)}
          >
            Sign in
          </Button>
          {!signupDisabled && (
            <Button
              btnBlock
              onClick={() => history.push(`/shutterbug/register`)}
            >
              Sign up
            </Button>
          )}
          <Button
            btnStyle="link"
            btnBlock
            className="text-center"
            href={`${marcomUrl}/search/?`}
          >
            <SearchIcon color="#0d84fe" className="mr-1" size={16} /> Find an
            event
          </Button>
        </div>
      </div>
    </div>
  );
};

CollapsableMenu.propTypes = propTypes;

export default CollapsableMenu;
